import { render, staticRenderFns } from "./PortalTextField.vue?vue&type=template&id=3c275bec"
import script from "./PortalTextField.vue?vue&type=script&lang=ts"
export * from "./PortalTextField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports